import { useImage } from 'global/cnr/contexts/useHelpers/useImage';
import { useContext } from 'react';
import { Image } from 'semantic-ui-react';
import { ParentContext } from '../../cnr/contexts/ParentContext';
import { gEnums } from '../../enums/globalEnums';
import { _animateTypes } from '../../motions/AnimateComponent';
import MotionComponent from '../../motions/MotionComponent';
import { _longPressTypes, LongPressWrapper } from 'global/wrappers/LongPressWrapper';

const Banner = () => {

  const parentContext = useContext(ParentContext);
  const { states } = parentContext ?? {};
  const { transition_state, currentSettings_state } = states;

  // Page Context
  const { aps_global, aps_styles } = _.get(currentSettings_state, 'gvviSettings', {});
  const { themedItems, banner: app_banner } = aps_global ?? {};
  const { appBanner: appBannerTheme } = themedItems ?? {};

  // Transition Context
  const { transitions } = transition_state ?? {};
  const transition = transitions ? transitions[_animateTypes.topBanner] : null;
  const { showTransition } = transition ?? {};

  const { banner: bannerFileName, bannerSize } = app_banner ?? {};
  const styleAndClass = aps_styles ? aps_styles[gEnums.projectStyles.appBanner] : {};

  const appImage = useImage({ fileName: bannerFileName, fileType: 'image', fullImage: true })
  const { currentUrls } = appImage ?? {}
  const { full: currentUrl } = currentUrls ?? {}

  const bannerImage = () => {
    const imageSize = bannerSize && bannerSize !== 'normal' ? bannerSize : 'large';
    return (
      <Image
        size={imageSize}
        className={`banner-image': 'gen'}`}
        centered
        src={currentUrl}
        alt=""
        style={{ display: 'block' }}
      />
    );
  };

  const content = () => (
    showTransition ? (
      <MotionComponent transition={transition}>{bannerImage()}</MotionComponent>
    ) : (
      bannerImage()
    )
  );

  return <LongPressWrapper
    longPressType={_longPressTypes.bannerImage}
    opts={{ appImage }}
  >
    {currentUrl ? (
      <div {...styleAndClass}>{content()}</div>
    ) : (
      <div></div>
    )}
  </LongPressWrapper>
};

export default Banner;
